import React, { Fragment, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { addRankSnail, getPlayersSlowdown, getSlowdownPlayerData, removeRankSnail } from '../../../actions/admin';

import Moment from 'react-moment';

import { size } from 'lodash';
import { UncontrolledPopover, PopoverBody, Button, Modal, ModalHeader, ModalBody } from 'reactstrap';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap/lib';
import SlowdownPlayerData from './SlowdownPlayerData';

const SlowdownPlayers = ({ offset }) => {

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(50);
  const [selectedPlayer, setSelectedPlayer] = useState('');
  const [openDetailView, setOpenDetailView] = useState(false);

  const playersSlowdown = useSelector(state => state.admin.playersSlowdown || []);
  const slowdownPlayerData = useSelector(state => state.admin.slowdownPlayerData || {});

  useEffect(() => {
    dispatch(getPlayersSlowdown());
  }, []);

  useEffect(() => {
    if (selectedPlayer) {
      dispatch(getSlowdownPlayerData(selectedPlayer));
    }
  }, [selectedPlayer]);

  const pagesCount = playersSlowdown ? Math.ceil(playersSlowdown.length / pageSize) : 0;

  const handleClick = (e, index) => {
    e.preventDefault();

    setCurrentPage(index);
  };

  const openDetailViewModal = (key) => {
    setOpenDetailView(true);
    setSelectedPlayer(key);
  };

  const closeDetailViewModal = () => {
    setOpenDetailView(false);
    setSelectedPlayer('');
  };

  const toggleRank = (item) => {
    if (item.rankS) {
      console.log("removeRankSnail", item);
      dispatch(removeRankSnail(item));
    } else {
      console.log("addRankSnail", item);
      dispatch(addRankSnail(item));
    }
  };

  return (
    <Fragment>
      <UncontrolledPopover popperClassName={`popover`} placement="right" trigger="focus" target="admin-help-button-slowdown">
        <PopoverBody className="popover-body">
          It shows the players who try to play the card at the very end of the time countdown, causing a slow game and a long waiting period for other players at the table.
        </PopoverBody>
      </UncontrolledPopover>
      <div className="admin-page-content">
        <h2>
          Slowdown
          <Button className="admin-help-button" id="admin-help-button-slowdown">
            ?
          </Button>
        </h2>
        <table style={{ width: '100%', fontSize: 12, color: '#fff' }}>
          <colgroup>
            <col span="1" className="" />
          </colgroup>
          <thead>
            <tr>
              <th style={{ textAlign: 'center' }}>
                Date
              </th>
              <th style={{ textAlign: 'center' }}>
                Name
              </th>
              <th style={{ textAlign: 'center' }}>
                Player Id
              </th>
              <th style={{ textAlign: 'center' }}>
                Count
              </th>
              <th style={{ textAlign: 'center' }}>
                View
              </th>
              <th style={{ textAlign: 'center' }}>
                Rank(Snail)
              </th>
            </tr>
          </thead>
          <tbody>
            {playersSlowdown.map((player, index) => (
              <tr key={index} className="row-alternate">
                <td className="allUsers-table-col">
                  <Moment format="DD-MM-YYYY, HH:mm:ss" locale="lv">
                    {player.date + offset}
                  </Moment>
                </td>
                <td className="allUsers-table-col">
                  {player.name}
                </td>
                <td className="allUsers-table-col">
                  {player.uid}
                  </td>
                <td className="allUsers-table-col">
                  {player.count}
                </td>
                <td className="allUsers-table-col">
                  <Button onClick={() => openDetailViewModal(player.uid)}>
                    View
                  </Button>
                </td>
                <td className="allUsers-table-col">
                  <Button color={player.rankS ? 'warning' : 'primary'} onClick={() => toggleRank(player)}>
                    {player.rankS ? 'Remove' : 'Add'}
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
          {pagesCount && size(playersSlowdown) > pageSize && (
            <div className="pagination-wrapper">
              <Pagination aria-label="Page navigation example">
                <PaginationItem disabled={currentPage === 0}>
                  <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, 0)} href="#">
                    {`‹‹‹`}
                  </PaginationLink>
                </PaginationItem>

                <PaginationItem disabled={currentPage <= 0}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => handleClick(e, currentPage - 1)}
                    previous
                    href="#"
                  />
                </PaginationItem>

                {[...Array(pagesCount)].map((page, i) => {
                  if (i > currentPage - 3 && i < currentPage + 3) {
                    return (
                      <PaginationItem active={i === currentPage} key={page}>
                        <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, i)} href="#">
                          {i + 1}
                        </PaginationLink>
                      </PaginationItem>
                    );
                  }

                  return null;
                })}

                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                  <PaginationLink
                    style={{ color: '#000' }}
                    onClick={e => handleClick(e, currentPage + 1)}
                    next
                    href="#"
                  />
                </PaginationItem>

                <PaginationItem disabled={currentPage >= pagesCount - 1}>
                    <PaginationLink style={{ color: '#000' }} onClick={e => handleClick(e, pagesCount - 1)} href="#">
                      {`›››`}
                    </PaginationLink>
                  </PaginationItem>
              </Pagination>
            </div>
          )}
        </table>
        <Modal container={'div > div'} returnFocusAfterClose={false} size="xlg" isOpen={openDetailView} toggle={closeDetailViewModal}>
          <ModalHeader toggle={closeDetailViewModal}>
            Detail View
          </ModalHeader>
          <ModalBody>
            <SlowdownPlayerData slowdownPlayerData={slowdownPlayerData} offset={offset} />
          </ModalBody>
        </Modal>
      </div>
    </Fragment>
  );
};

export default SlowdownPlayers;
